var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0004 15.6C13.6749 15.6 12.6004 16.6745 12.6004 18V60C12.6004 61.3255 13.6749 62.4 15.0004 62.4H57.0004C58.3259 62.4 59.4004 61.3255 59.4004 60V18C59.4004 16.6745 58.3259 15.6 57.0004 15.6H15.0004ZM7.65039 18C7.65039 12.6981 9.69846 10.65 15.0004 10.65H57.0004C62.3023 10.65 64.3504 12.6981 64.3504 18V60C64.3504 65.302 62.3023 67.35 57.0004 67.35H15.0004C9.69846 67.35 7.65039 65.302 7.65039 60V18Z",
    fill: "#C84B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.375 4.5C50.239 4.5 51.75 5.82216 51.75 7.45312V17.2969C51.75 18.9278 50.239 20.25 48.375 20.25C46.511 20.25 45 18.9278 45 17.2969V7.45312C45 5.82216 46.511 4.5 48.375 4.5Z",
    fill: "#C84B31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.625 4.5C25.489 4.5 27 5.82216 27 7.45312V17.2969C27 18.9278 25.489 20.25 23.625 20.25C21.761 20.25 20.25 18.9278 20.25 17.2969V7.45312C20.25 5.82216 21.761 4.5 23.625 4.5Z",
    fill: "#C84B31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 29.25C9 28.0074 10.4222 27 12.1765 27H59.8235C61.5778 27 63 28.0074 63 29.25C63 30.4926 61.5778 31.5 59.8235 31.5H12.1765C10.4222 31.5 9 30.4926 9 29.25Z",
    fill: "#C84B31"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.728006d93fadaec516b21683bd2c7fe8.svg";
export { ForwardRef as ReactComponent };